import { render } from "./PaymentAnimationModal.vue?vue&type=template&id=3ada123a&scoped=true"
import script from "./PaymentAnimationModal.vue?vue&type=script&lang=js"
export * from "./PaymentAnimationModal.vue?vue&type=script&lang=js"

import "./PaymentAnimationModal.vue?vue&type=style&index=0&id=3ada123a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ada123a"]])

export default __exports__